import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { colors } from "../../theme/colors";

const { Grey, Primary, Base } = colors;

// Billing-local styles: the legacy theme paints even text buttons as filled
// pills. Restore clear action variants without changing other Manager pages.
const billingContentSx = {
  color: Grey[900],
  "& .MuiButton-root": {
    borderRadius: 2,
    minHeight: 40,
    maxWidth: "100%",
    px: 2,
    py: 1,
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 700,
    whiteSpace: "normal",
    textAlign: "center",
    boxShadow: "none",
    "@media (pointer: coarse)": { minHeight: 44 },
    "&.Mui-focusVisible": {
      outline: `2px solid ${Primary[800]}`,
      outlineOffset: 3,
    },
  },
  "& .MuiButton-contained": {
    backgroundColor: Primary[800],
    borderColor: Primary[800],
    color: Base.White,
    "&:hover, &:focus": {
      backgroundColor: Primary[900],
      borderColor: Primary[900],
      boxShadow: "none",
    },
  },
  "& .MuiButton-outlined": {
    backgroundColor: Base.White,
    borderColor: Grey[300],
    color: Grey[700],
    "&:hover, &:focus": {
      backgroundColor: Grey[50],
      borderColor: Grey[400],
      boxShadow: "none",
    },
  },
  "& .MuiButton-text": {
    backgroundColor: "transparent",
    borderColor: "transparent",
    color: Grey[600],
    fontWeight: 400,
    "&:hover, &:focus": {
      backgroundColor: Grey[100],
      borderColor: "transparent",
      color: Grey[900],
      boxShadow: "none",
    },
  },
  "& .MuiButton-root.Mui-disabled": {
    backgroundColor: Grey[100],
    borderColor: Grey[200],
    color: Grey[400],
    boxShadow: "none",
  },
  "& .MuiAlert-root": {
    borderRadius: 2,
    fontSize: 14,
    lineHeight: "22px",
    alignItems: "flex-start",
  },
  "& .MuiAlert-standardInfo": {
    backgroundColor: Grey[50],
    color: Grey[700],
    border: `1px solid ${Grey[200]}`,
    "& .MuiAlert-icon": { color: Primary[800] },
  },
  "& .MuiTypography-h6": { fontSize: 18, lineHeight: "26px", fontWeight: 700 },
};

const BillingPageLayout = React.forwardRef(function BillingPageLayout(
  { title, subtitle, children },
  ref
) {
  return (
    <Box
      component="main"
      ref={ref}
      sx={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        flexGrow: 1,
        p: { xs: 2, md: 3 },
      }}
    >
      <Stack
        component="header"
        spacing={1}
        sx={{ pt: 2, pb: 3, maxWidth: 768 }}
      >
        <Typography
          component="h1"
          variant="h5"
          sx={{
            fontSize: 24,
            lineHeight: "32px",
            fontWeight: 700,
            color: Grey[900],
          }}
        >
          {title}
        </Typography>
        <Typography sx={{ fontSize: 14, lineHeight: "22px", color: Grey[600] }}>
          {subtitle}
        </Typography>
      </Stack>
      <Paper
        variant="outlined"
        sx={{
          width: "100%",
          maxWidth: 768,
          boxSizing: "border-box",
          borderRadius: 3,
          borderColor: Grey[200],
          boxShadow: "none",
          p: { xs: 2, sm: 3 },
          ...billingContentSx,
        }}
      >
        <Stack spacing={3} sx={{ minWidth: 0 }}>
          {children}
        </Stack>
      </Paper>
    </Box>
  );
});

export default BillingPageLayout;
